import React from 'react';
import "./DocumentsPage.scss";
import documentsdog from '../../assets/documentsdog.png';

interface IDocumentsPageProps {
  isLoading: boolean;
  error?: any;
}

const DocumentsPage: React.FC<IDocumentsPageProps> = ({ isLoading, error }) => {
  const getStatusMessage = () => {
    if (isLoading && !error) {
      return {
        title: "Preparing your download...",
        subtitle: "Please check your browser's downloads."
      };
    }
    
    if (!isLoading && !error) {
      return {
        title: "Download started...",
        subtitle: "Please check your browser's downloads."
      };
    }
    
    if (error) {
      return {
        title: "Download failed...",
        subtitle: "Please check your browser's downloads."
      };
    }
  };

  const status = getStatusMessage();

  const handleContactSupport = () => {
    // Add contact support functionality
    window.location.href = 'mailto:support@eagerdog.com';
  };

  const handleBackToEventSearch = () => {
    // Navigate back to events page
    window.location.href = '/';
  };

  return (
    <div className="DocumentsPage">
      <div className="content-wrapper">
        <div className="text-content">
          <h1 className="title">{status?.title}</h1>
          <p className="subtitle">{status?.subtitle}</p>
          
          <div className="actions">
            <button className="action-link" onClick={handleContactSupport}>
              Contact support
            </button>
            <button className="action-link" onClick={handleBackToEventSearch}>
              Back to event search
            </button>
          </div>
        </div>
        
        <div className="dog-image">
          <img src={documentsdog} alt="Eager Dog mascot" />
        </div>
      </div>
    </div>
  );
};

export default DocumentsPage;
